import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {MaintenanceData, ModalMaintenanceHandler} from 'types'
import {setModalMaintenanceHandler} from 'utils'
import {ModalMaintenanceProviderProps} from './ModalMaintenanceProps'
import {ModalMaintenanceContext} from './ModalMaintenanceContext'
import ModalMaintenanceItem from './ModalMaintenanceItem'

export default function ModalMaintenanceProvider({
  children,
}: ModalMaintenanceProviderProps) {
  const [visible, setVisible] = useState(false)
  const [data, setData] = useState<MaintenanceData>({})

  const handleShowModal = useCallback(
    (modalVisible: boolean, maintenanceData: MaintenanceData) => {
      setVisible(modalVisible)
      setData(maintenanceData)
    },
    [],
  )

  const handleClickOk = useCallback(() => setVisible((prev) => !prev), [])

  const handleRenderModalMaintenance = useMemo(
    () => (
      <ModalMaintenanceItem
        visible={visible}
        data={data}
        onClick={handleClickOk}
      />
    ),
    [data, handleClickOk, visible],
  )

  const handler = useMemo<ModalMaintenanceHandler>(
    () => ({
      visible,
      showModal: handleShowModal,
    }),
    [handleShowModal, visible],
  )

  useEffect(() => setModalMaintenanceHandler(handler), [handler])

  return (
    <ModalMaintenanceContext.Provider value={handler}>
      {handleRenderModalMaintenance}
      {children}
    </ModalMaintenanceContext.Provider>
  )
}
